import React, { createContext, useEffect} from 'react';
import { EventApi } from '../Api/EventApi';
import { Event } from '../models/Event';

interface EventProviderProps {
    children: React.ReactNode;
}

interface EventContextProps {
    events:Event[];
    upCommingEvents:Event[];
    pastEvents:Event[];
}

export const EventContext = createContext<EventContextProps>({
    events:[],
    upCommingEvents:[],
    pastEvents:[]
});

export const EventProvider: React.FC<EventProviderProps> = ({children}) => {
    const [events, setEvents] = React.useState<Event[]>([]);
    const [upCommingEvents, setUpCommingEvents] = React.useState<Event[]>([]);
    const [pastEvents, setPastEvents] = React.useState<Event[]>([]);
    const [loading, setLoading] = React.useState<boolean>(true);
    useEffect(() => {
        EventApi.getCases().then((data) => {
            setEvents(data.items)
        });
    }, []);

    useEffect(() => {
        const now = new Date();
        // sort by upcoming events ( the closest event first)
        const upCommingEvents = events.filter((event) => event.EndDate >= now).sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
        setUpCommingEvents(upCommingEvents);
        // sort by past events ( the closest event first)
        const pastEvents = events.filter((event) => new Date(event.EndDate) < now).sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());

        setPastEvents(pastEvents);
    }, [events]);
     return (
        <EventContext.Provider value={{
            events,
            upCommingEvents,
            pastEvents
        }}>
            {children}
        </EventContext.Provider>
    );
};